/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, BodyText } from '@vaisala-rockhopper/components';
import './MobileCalculatorHeader.scss';
import { ReactComponent as MethodIcon1 } from '../../../assets/icons/method_icon_1.svg';
import { ReactComponent as MethodIcon2 } from '../../../assets/icons/method_icon_2.svg';
import { ReactComponent as MethodIcon3 } from '../../../assets/icons/method_icon_3.svg';
import MethodThumbnail1 from '../../../assets/img/method_thumbnail_1.jpg';
import MethodThumbnail2 from '../../../assets/img/method_thumbnail_2.jpg';
import MethodThumbnail3 from '../../../assets/img/method_thumbnail_3.jpg';

interface Method {
  id: number;
  heading: string;
  subHeading: string;
  longDesc: string;
}

interface MobileCalculatorHeaderProps {
  activeMethod: number;
  theme: string;
  setHeaderSize: (value: number) => void;
  calculatorScrollPosition: number;
  method: Method;
}

const MobileCalculatorHeader = ({ activeMethod, theme, setHeaderSize, calculatorScrollPosition, method }: MobileCalculatorHeaderProps) => {
  const { t } = useTranslation();
  const containerRef = React.useRef<HTMLDivElement>(null);

  const images = [MethodThumbnail1, MethodThumbnail2, MethodThumbnail3];
  const icons = [<MethodIcon1 />, <MethodIcon2 />, <MethodIcon3 />];

  React.useEffect(() => {
    const handleResize = () => {
      if (containerRef.current && method) {
        const height = containerRef.current.clientHeight;
        if (height) {
          setHeaderSize(height);
        }
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [containerRef, setHeaderSize, method]);

  const calcOpacity = 1 - calculatorScrollPosition / 250;

  return (
    <div
      ref={containerRef}
      className={`mobile-calculator-header ${
        activeMethod > -1 ? 'mobile-calculator-header--active' : ''
      } ${theme} mobile-calculator-header--method-${activeMethod}`}
      style={{ backgroundImage: `url(${images[activeMethod]})` }}
    >
      <div
        className="mobile-calculator-header__animation-wrap"
        style={{
          opacity: calcOpacity,
          transform: `translateY(${0 - calculatorScrollPosition / 10}px)`,
        }}
      >
        <Heading level={1}>{t(method.heading)}</Heading>
        {icons[activeMethod]}
        <BodyText>{t(method.longDesc)}</BodyText>
      </div>
    </div>
  );
};

export default MobileCalculatorHeader;
